import { z } from "zod"

import * as m from "@/paraglide/messages"

export const loginSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, m.signup_error_email_required())
    .pipe(z.email(m.signup_error_email_invalid())),
  password: z.string().min(1, m.signup_error_password_confirm_required()),
})

export type LoginValues = z.infer<typeof loginSchema>
